<template>
  <div class="elevation-1 px-4 mx-1 py-4 my-4 grey lighten-2" dense>
    <v-row>
      <v-col cols="12">
        <b v-show="preferencesOfOption.length === 0">{{ argueBelief ? $t('scenario.associateElementsForScenarioForThisBelief') : $t('scenario.associateElementsForScenario') }}</b>
        <b v-show="preferencesOfOption.length > 0">{{ $t('scenario.otherPossibleScenario') }} ?</b>
      </v-col>
      <v-col cols="12">
        <input-scenario-elements
          :create-new-scenario=true
          :validate-scenarii="validateScenarii"
          :available-elements="elements"
          :update-available-elements="updateElementList"
          :calling-api="callingApi"
          v-on="$listeners"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import InputScenarioElements from '@/components/global/InputScenarioElements';

export default {
  name: 'AddElementsToScenarii',

  components: { InputScenarioElements },

  props: {
    preferencesOfOption: {
      type: Array,
      required: true,
    },
    callingApi: {
      type: Boolean,
      required: false,
      default: false,
    },
    addElementList: {
      type: Function,
      required: true,
    },
    updateElementList: {
      type: Function,
      required: true,
    },
    validateScenarii: {
      type: Function,
      required: true,
    },
    elements: {
      type: Array,
      required: true,
    },
    argueBelief: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
};
</script>